import { useCallback } from 'react';
import { Alert } from 'react-native';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { useUserUUID } from '@annunciate/core';
import { upsertDownloads, fetchValidDownload, DownloadCancelledError, } from '../../utils';
export const useDownloadCreateMutation = (options) => {
    const uuid = useUserUUID(true);
    const client = useQueryClient();
    const mutationFn = useCallback(async (item) => {
        const { content, download } = await fetchValidDownload(client, item.id);
        if (content.asset) {
            content.asset.stream = download;
        }
        if (uuid) {
            const upsertResponse = await upsertDownloads({
                uuid,
                items: [content],
                client,
            });
            const contentItems = await upsertResponse.promise;
            return contentItems;
        }
        else {
            return [];
        }
    }, [client]);
    return useMutation({
        mutationFn,
        onError: (err) => {
            if (!(err instanceof DownloadCancelledError)) {
                Alert.alert("Download Failed");
            }
        },
        ...options,
    });
};
//# sourceMappingURL=useDownloadCreateMutation.js.map